import { Button, NonIdealState, Popover, Spinner } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import Padding from "common/fragments/Padding";
import { ButtonVariant } from "common/views/button/Button.view";
import MutationButton from "common/views/button/MutationButton";
import Icon from "common/views/icon/Icon";
import Label from "core/components/label/Label";
import { Component } from "react";
import { MutationType } from "typegraph";
import { FlexJustify } from "../../../../common/fragments/Flex";
import { CardView } from "../../../../common/views/card/Card.view";
import { default as HeadingView, HeadingVariant } from "../../../../common/views/heading/Heading.view";
import { Query } from "../../../../core/api/typedQuery";
import { TopicSubscription } from "../../entity/TopicSubscription";
import TopcicSubscriptionForm from "./TopicSubscriptionForm";

interface ITopicSubscriptionManageProps {

}

const SubQuery = Query.queryMany<TopicSubscription, any>(TopicSubscription);

export default class TopicSubscriptionManage extends Component<ITopicSubscriptionManageProps> {


	private renderForm(sub: TopicSubscription) {
		return (
			<Padding.Base>
				<TopcicSubscriptionForm topicId={sub.topicEntity.id} />
			</Padding.Base>
		);
	}

	private renderList(subs: TopicSubscription[], refetch: () => void) {
		return subs.map((s) =>
			<CardView key={s.id} viewKey="topic.sub">
				<Padding.Base>
					<FlexJustify>
						<HeadingView viewKey="topic.sub.title" variant={HeadingVariant.H5}>{s.topicEntity && s.topicEntity.name}</HeadingView>

						<div>
							<Popover content={this.renderForm(s)}>
								<Button minimal={true} icon={IconNames.COG} />
							</Popover>

							<MutationButton
								variant={ButtonVariant.PRIMARY}
								viewKey="topic.sub.delete"						
								clazz={TopicSubscription}
								params={{ id: s.id }}
								clearCacheOnSuccess={true}
								method={MutationType.DELETE}
								onSuccess={()=>refetch()}
							>
								<Icon icon={IconNames.TRASH} />
							</MutationButton>
						</div>
					</FlexJustify>
				</Padding.Base>
			</CardView>
		);
	}

	public render() {
		return (
			<SubQuery params={{}}>
				{
					({data, loading, refetch}) => {

						if (loading) {
							return <Spinner/>;
						}

						if (!data) {
							return (
								<NonIdealState
									title={<Label k="topic.subs.empty" v="No Subscriptions" />}
									description={<Label k="topic.subs.empty.desc" v="Subscribe to a post with the follow button" />}
								/>
							);
						}

						return this.renderList(data,refetch);
					}
				}
			</SubQuery>
		);
	}

}



// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/TopicSubscriptionManage.tsx